import React from 'react'

import {
  HiOutlineDesktopComputer,
  HiOutlineMoon,
  HiOutlineSun,
} from 'react-icons/hi'

import { RoleTone, theme } from '../../constants'
import { useRedesignTheme } from '../../theme'

import { ThemeOption, ThemeOptions, ThemeSelectorGroup } from './styles'

const options = [
  {
    value: 'system',
    label: 'Sistema',
    icon: HiOutlineDesktopComputer,
  },
  { value: 'light', label: 'Claro', icon: HiOutlineSun },
  { value: 'dark', label: 'Oscuro', icon: HiOutlineMoon },
] as const

interface ThemeSelectorProps {
  role?: RoleTone
}

const ThemeSelector = ({ role = 'student' }: ThemeSelectorProps) => {
  const { mode, setMode } = useRedesignTheme()
  const roleColor = theme.roleColors[role]

  return (
    <ThemeSelectorGroup>
      <span id="redesign-theme-label">Tema</span>
      <ThemeOptions role="radiogroup" aria-labelledby="redesign-theme-label">
        {options.map(({ value, label, icon: Icon }) => (
          <ThemeOption
            key={value}
            type="button"
            role="radio"
            aria-checked={mode === value}
            $selected={mode === value}
            $role={role}
            style={
              {
                '--theme-option-role-main': roleColor.main,
                '--theme-option-role-text': roleColor.text,
              } as React.CSSProperties
            }
            onClick={() => setMode(value)}
          >
            <Icon aria-hidden="true" />
            {label}
          </ThemeOption>
        ))}
      </ThemeOptions>
    </ThemeSelectorGroup>
  )
}

export default ThemeSelector
